import {HTTP_METHODS} from '@/utils/constants/httpMethods';

export const GLOBAL_API_CONFIG = {
  FILE_UPLOAD: {
    endPoint: '/upload',
    method: HTTP_METHODS.POST,
    contentType: 'multipart/form-data'
  }
};
